exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* metro-ui-components@9.20.0 */\n/*\n@import \"./util/common\";\n@import \"../scss/metro/03_generic/fonts\";\n\n@include prefixed() {\n  @include Fonts();\n}\n*/\n", ""]);
